import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewProductsComponent } from './new-products.component';
import { CardBasicModule } from '../../../app/shared/component/common/card-basic/card-basic.module';
import { IdsModule } from '../../../app/ids.module';

@NgModule({
  imports: [
    CommonModule, 
    CardBasicModule, 
    IdsModule
  ],
  declarations: [NewProductsComponent],
  exports: [NewProductsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NewProductsModule { }
